import React from 'react'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid'
import Img from 'gatsby-image'
import Typography from '@material-ui/core/Typography'


export default class Nameplate extends React.Component{
    render(){
	var imgs = this.props.imgs;
	return(
	    <div className="section primary">
		<Grid>
		    <Row>
			<Col xs={8} xsOffset={2} sm={6} smOffset={3} lg={6} lgOffset={3}>
			    <Img sizes={imgs.logo.white.childImageSharp.sizes}
				 className="image-contain-hotfix" />
			</Col>
		    </Row>
		</Grid>
	    </div>
	)
    }
}



// WEBPACK FOOTER //
// ./src/components/splash/nameplate/index.jsx